export const chatCitationResources = {
  "zh-CN": {
    chat: {
      citationPreview: {
        common: {
          close: "关闭预览",
          retryReadVersion: "重试读取引用版本",
          loadingVersion: "正在读取引用版本",
          loadingDocument: "正在加载原文",
          noPreciseImagePosition: "未取得图片精确位置",
          citationSourceFallback: "引用来源",
          unknownDocument: "未知文档",
          imageFallback: "引用图片",
        },
        header: {
          relatedCitation: "对应正文引用 [{{index}}]",
          download: "下载",
        },
        fallback: {
          documentUnavailable: "原文档已删除或不可访问",
          documentUnavailableDescription: "引用来源《{{title}}》已从知识库删除，历史引用仅保留原文摘录。",
          section: "章节：{{heading}}",
          viewExcerpt: "查看引用原文摘录",
          viewSource: "查看来源",
        },
        email: {
          breadcrumb: "来自邮件：",
          fallbackSubject: "邮件",
        },
        version: {
          fixedBody: "固定正文版本",
          fixedParse: "固定解析版本",
          fixedSnapshot: "固定正文快照",
          unknown: "版本未知",
          revision: "修订 {{revision}}",
          fixedRevision: "固定修订",
          original: "原始版本",
          fixedReading: "固定阅读版本",
        },
        sourceRole: {
          derived: "生成内容依据的原文",
          cited: "引用时的来源",
          citationTime: "引用时的来源",
        },
        fixedReading: {
          imageUnreadable: "图片不可读取",
          imageLoading: "正在加载引用图片",
          versionLoading: "正在加载引用版本",
          versionUnreadable: "引用阅读版本不可读取",
          retryImage: "重试",
          retryVersion: "重试读取引用版本",
          noPrecisePosition: "此处展示引用时的完整阅读正文，尚无正文精确位置。",
        },
        fixedMarkdown: {
          videoUnreadable: "引用视频版本无法播放，保留下面的固定描述。不会替换为当前视频。",
          retryVideo: "重试引用视频",
          videoLoading: "正在加载引用视频",
          clipRangeStart: "引用片段：{{start}} 秒",
          clipRange: "引用片段：{{start}} 至 {{end}} 秒",
          noPreciseClipTime: "未取得片段精确时间，仅打开原视频。",
          imageUnreadable: "引用原图不可读取，下面保留固定识别正文。",
          retryImage: "重试原图",
          imageLoading: "正在加载引用原图",
          bodySnapshot: "固定正文快照 · 引用时使用的内容",
          imageAlt: "图片：{{alt}}",
          snapshotHasNoImageBytes: "此正文快照未包含图片字节",
          versionLoading: "正在加载引用版本",
          bodyUnreadable: "引用正文版本不可读取",
          retryVersion: "重试读取引用版本",
          imageLabel: "引用原图",
          contentDescription: "展示检索所用的固定正文，保留当时的解析或识别内容。",
          noPreciseTextPosition: "尚无正文精确位置。",
        },
        fixedPdf: {
          sourceName: "PDF 引用来源",
          academicIssues: "此依据含识别疑点，请对照原始 PDF 核对数字、单位与注号。",
          academicUnchecked: "此依据尚未完成原始 PDF 核对。",
          academicReferenceOnly: "仅为论文列出的出处线索，尚未读取所引文献全文。",
          versionUnreadable: "引用版本不可读取",
          blockMissing: "指定版本中找不到完整的引用块，未使用其他位置替代。",
          sourceUnavailable: "来源文件、解析版本或读取权限已不可用。此处保留回答时的摘录。",
          reading: "正在读取引用版本",
          sourceFileName: "引用来源.pdf",
        },
        fixedOffice: {
          sourceName: "引用来源.{{format}}",
          sourceAtCitation: "引用时的来源",
          excerpt: "引用摘录",
          sourceCellDescription: "下方展示引用时的原文件；摘录中的正文位置不代表原文件的单元格位置。",
          versionUnreadable: "引用版本不可读取",
          sourceUnavailable: "可能缺少读取权限、修订已删除或来源校验失败。此处保留回答时的摘录。",
          loading: "正在读取引用版本",
        },
        unknownHistory: {
          viewingCurrent: "正在查看当前原文",
          unverifiable: "历史版本无法核验",
          explanation: "这条引用没有保存可核验的历史版本身份。当前原文可能已经变化，不能作为当时内容的证明。",
          backToExcerpt: "返回历史摘录",
          viewCurrent: "查看当前原文",
          close: "关闭",
          savedExcerpt: "当时保存的引用摘录",
        },
        pptNotes: {
          sectionLabel: "演讲者备注",
          pageTitle: "第 {{page}} 页 · 演讲者备注",
          loading: "正在读取引用版本的备注…",
          unreadable: "备注不可读取，保留回答时的摘录。",
          retry: "重试读取备注",
          empty: "引用版本中此页没有演讲者备注。",
        },
        popover: {
          relevanceTitle: "仅表示本次检索结果内的相对位置，不代表相关概率或跨查询的绝对分数",
          relevanceLabel: "本次相对相关度：{{score}}/100",
        },
      },
    },
  },
  "en-US": {
    chat: {
      citationPreview: {
        common: {
          close: "Close preview",
          retryReadVersion: "Retry reading cited version",
          loadingVersion: "Loading cited version",
          loadingDocument: "Loading source document",
          noPreciseImagePosition: "No precise image location is available",
          citationSourceFallback: "Citation source",
          unknownDocument: "Unknown document",
          imageFallback: "Cited image",
        },
        header: {
          relatedCitation: "Citation in the response [{{index}}]",
          download: "Download",
        },
        fallback: {
          documentUnavailable: "The source document was deleted or is unavailable",
          documentUnavailableDescription: "Citation source “{{title}}” was deleted from the knowledge base. Only the original excerpt is retained in this conversation.",
          section: "Section: {{heading}}",
          viewExcerpt: "View cited excerpt",
          viewSource: "View source",
        },
        email: {
          breadcrumb: "From email:",
          fallbackSubject: "Email",
        },
        version: {
          fixedBody: "Fixed text version",
          fixedParse: "Fixed parse version",
          fixedSnapshot: "Fixed body snapshot",
          unknown: "Version unknown",
          revision: "Revision {{revision}}",
          fixedRevision: "Fixed revision",
          original: "Original version",
          fixedReading: "Fixed reading version",
        },
        sourceRole: {
          derived: "Original source used to generate this content",
          cited: "Source at citation time",
          citationTime: "Source at citation time",
        },
        fixedReading: {
          imageUnreadable: "Image cannot be read",
          imageLoading: "Loading cited image",
          versionLoading: "Loading cited version",
          versionUnreadable: "Cited reading version cannot be read",
          retryImage: "Retry",
          retryVersion: "Retry reading cited version",
          noPrecisePosition: "This is the complete reading text from the time of citation. No precise text position is available.",
        },
        fixedMarkdown: {
          videoUnreadable: "The cited video version cannot be played. The fixed description is preserved below and will not be replaced with the current video.",
          retryVideo: "Retry cited video",
          videoLoading: "Loading cited video",
          clipRangeStart: "Cited segment: {{start}} sec",
          clipRange: "Cited segment: {{start}}–{{end}} sec",
          noPreciseClipTime: "No precise segment time is available. Opening the original video.",
          imageUnreadable: "The cited image cannot be read. The fixed recognized text is preserved below.",
          retryImage: "Retry image",
          imageLoading: "Loading cited image",
          bodySnapshot: "Fixed body snapshot · Content used at citation time",
          imageAlt: "Image: {{alt}}",
          snapshotHasNoImageBytes: "This body snapshot does not include image bytes",
          versionLoading: "Loading cited version",
          bodyUnreadable: "Cited body version cannot be read",
          retryVersion: "Retry reading cited version",
          imageLabel: "Cited image",
          contentDescription: "Showing the fixed text used for retrieval, preserving the parsed or recognized content from that time.",
          noPreciseTextPosition: "No precise text position is available.",
        },
        fixedPdf: {
          sourceName: "PDF citation source",
          academicIssues: "This evidence has recognition concerns. Check numbers, units, and reference markers against the original PDF.",
          academicUnchecked: "This evidence has not been checked against the original PDF.",
          academicReferenceOnly: "This is a reference listed in the paper; the cited work's full text has not been read.",
          versionUnreadable: "Cited version cannot be read",
          blockMissing: "The complete cited block could not be found in the specified version. No other location was substituted.",
          sourceUnavailable: "The source file, parse version, or read permission is unavailable. The excerpt from the response is preserved here.",
          reading: "Reading cited version",
          sourceFileName: "citation-source.pdf",
        },
        fixedOffice: {
          sourceName: "Citation source.{{format}}",
          sourceAtCitation: "Source at citation time",
          excerpt: "Cited excerpt",
          sourceCellDescription: "The original file from citation time is shown below. The excerpt's text position does not identify a cell in the original file.",
          versionUnreadable: "Cited version cannot be read",
          sourceUnavailable: "Read permission may be missing, the revision may have been deleted, or source verification failed. The excerpt from the response is preserved here.",
          loading: "Reading cited version",
        },
        unknownHistory: {
          viewingCurrent: "Viewing the current source",
          unverifiable: "Historical version cannot be verified",
          explanation: "This citation has no saved identity for a verifiable historical version. The current source may have changed and cannot prove what was present at the time.",
          backToExcerpt: "Back to historical excerpt",
          viewCurrent: "View current source",
          close: "Close",
          savedExcerpt: "Excerpt saved at the time",
        },
        pptNotes: {
          sectionLabel: "Speaker notes",
          pageTitle: "Slide {{page}} · Speaker notes",
          loading: "Loading notes from the cited version…",
          unreadable: "Notes cannot be read. The excerpt from the response is preserved.",
          retry: "Retry reading notes",
          empty: "This slide has no speaker notes in the cited version.",
        },
        popover: {
          relevanceTitle: "Shows only the relative position within these search results. It is not a probability of relevance or an absolute score across searches.",
          relevanceLabel: "Relative relevance in this search: {{score}}/100",
        },
      },
    },
  },
} as const;
